import { Product } from "../../../components/organisation/onboarding/entities/Products";
import { getData } from "../rest";

// return all products sorded by Name (asc)
export const getProducts = async (): Promise<Product[]> => {
    const products = await getData<Product[]>(`/stripe/products`);
    return products.sort((a: Product, b: Product) => (a.name > b.name ? 1 : -1));
};
